import type { FAQItem } from "@/lib/products";

/**
 * FAQ data for the Reddit Advanced Search Generator tool
 * Separated from view layer for maintainability
 */
export const redditAdvancedSearchFAQ: FAQItem[] = [
  {
    question: "How does Reddit Advanced Search work?",
    answer:
      "The tool provides a visual interface to build complex Reddit search queries without memorizing operators. You specify keywords, subreddits, authors, domains, filters, and sorting options, and the tool generates a search query that works directly on Reddit. It handles all the syntax like 'subreddit:', 'author:', 'site:', etc. automatically.",
  },
  {
    question: "What search operators are supported?",
    answer:
      "The tool supports Reddit's native search operators including: subreddit filtering (subreddit:), author filtering (author:), domain filtering for link posts (site:), title-only searches (title:), self-post filtering (self:yes), NSFW content filtering (nsfw:yes/no), and various sorting options (relevance, hot, top, new, most comments) with time ranges.",
  },
  {
    question: "Can I search within a specific subreddit?",
    answer:
      "Yes! Use the 'Subreddit' field to search within a specific subreddit. You can enter just the subreddit name (e.g., 'marketing') or with the 'r/' prefix (e.g., 'r/marketing')—the tool handles both formats. This is perfect for finding discussions within niche communities or specific topics.",
  },
  {
    question: "How do I find posts by a specific user?",
    answer:
      "Enter the username in the 'Author' field. You can use just the username or include the 'u/' prefix—the tool formats it correctly. Combine this with other filters to find specific content from a user, such as all their posts in a particular subreddit or posts containing certain keywords.",
  },
  {
    question: "What does 'Search Title Only' do?",
    answer:
      "When enabled, the search only looks at post titles, not the post content or comments. This is useful when you know roughly what the title should contain but don't need to search through the full post text. It's faster and more precise for finding specific types of posts.",
  },
  {
    question: "What's the difference between 'Self Posts Only' and regular posts?",
    answer:
      "'Self Posts Only' filters to show only text-based posts (where users write content directly on Reddit) and excludes link posts (where users share external URLs). This is useful for finding discussions, questions, and original content rather than shared articles or videos.",
  },
  {
    question: "How do I filter NSFW content?",
    answer:
      "You can choose to 'Hide NSFW' (exclude NSFW posts), 'Include NSFW' (show all posts), or 'Only NSFW' (show only NSFW posts). This helps you control what content appears in your search results based on your preferences and needs.",
  },
  {
    question: "Can I sort results by different criteria?",
    answer:
      "Yes! You can sort by relevance (best matches), hot (trending now), top (highest upvotes), new (most recent), or most comments (most discussion). You can also combine sorting with time ranges (all time, past year, month, week, day, or hour) to find content from specific periods.",
  },
  {
    question: "Is this tool free to use?",
    answer:
      "Yes, completely free with no registration required. You can build as many Reddit search queries as you need. There are no limits, no watermarks, and no hidden fees. It's part of our free tools collection to help researchers, marketers, and anyone who needs to find specific discussions on Reddit.",
  },
];
